// The custom RELAXTER product form keeps native checkout submission for Buy it
// now. Valid Add to cart submissions use Shopify's native drawer renderer.
(() => {
  if (window.rlxProductDrawerBound) return;
  window.rlxProductDrawerBound = true;
  const pending = new WeakSet();

  document.addEventListener('submit', async (event) => {
    const form = event.target;
    if (!(form instanceof HTMLFormElement) || !form.matches('.rlx-form')) return;
    const root = form.closest('[data-rlx-pdp]');
    const drawer = document.querySelector('cart-drawer');
    if (!root || !drawer || event.defaultPrevented) return;
    if (pending.has(form)) {
      event.preventDefault();
      return;
    }
    if (event.submitter?.matches('[data-rlx-buy]')) return;
    if (!form.checkValidity()) {
      event.preventDefault();
      form.reportValidity();
      return;
    }

    event.preventDefault();
    pending.add(form);
    const input = form.querySelector('[name="id"]');
    const variantId = input?.value;
    const buttons = Array.from(root.querySelectorAll('[data-rlx-add], [data-rlx-buy], [data-rlx-sticky-add]'));
    const disabledBefore = buttons.map(button => button.disabled);
    const label = root.querySelector('[data-rlx-add-text]');
    const labelBefore = label?.textContent;
    const message = root.querySelector('[data-rlx-cart-error]');
    if (message) message.hidden = true;
    buttons.forEach(button => { button.disabled = true; });
    form.setAttribute('aria-busy', 'true');
    if (label) label.textContent = 'Adding…';

    try {
      const body = new FormData(form);
      body.set('sections', drawer.getSectionsToRender().map(section => section.id).join(','));
      body.set('sections_url', window.location.pathname);
      drawer.setActiveElement(event.submitter || document.activeElement);
      const response = await fetch(`${window.routes.cart_add_url}.js`, {
        method: 'POST',
        headers: { Accept: 'application/json', 'X-Requested-With': 'XMLHttpRequest' },
        body,
      });
      const state = await response.json();
      if (!response.ok || state.status) throw new Error(state.description || 'We could not add this option. Please try again.');

      // A successful add with a missing section is not retried: the item is
      // already in the cart. Show the cart page to avoid a duplicate addition.
      const sections = drawer.getSectionsToRender();
      if (sections.some(section => !state.sections?.[section.id])) {
        window.location.assign(window.routes.cart_url);
        return;
      }
      drawer.classList.remove('is-empty');
      drawer.renderContents(state);
      if (typeof publish === 'function' && typeof PUB_SUB_EVENTS !== 'undefined') {
        publish(PUB_SUB_EVENTS.cartUpdate, { source: 'relaxter-product-form', productVariantId: variantId, cartData: state });
      }
    } catch (error) {
      if (message) {
        message.textContent = error.message || 'We could not add this option. Please try again.';
        message.hidden = false;
      }
    } finally {
      pending.delete(form);
      form.removeAttribute('aria-busy');
      // A variant change during the request has already set the current
      // availability. Do not overwrite it with the submitted variant's state.
      if (input?.value === variantId) {
        buttons.forEach((button, index) => { button.disabled = disabledBefore[index]; });
        if (label) label.textContent = labelBefore;
      }
    }
  });
})();
